import { FORM_LEN, STR_MAX, STR_MIN } from "@/constants";

// export function formatDate(isoString: string): string {
//   const date = new Date(isoString);

//   // Options for the format: 3 July, 2025
//   const options: Intl.DateTimeFormatOptions = {
//     day: "numeric",
//     month: "long",
//     year: "numeric",
//   };

//   return date.toLocaleDateString("en-GB", options);
// }

/**
 * Converts a possibly relative status URL to an absolute one.
 * If the URL is already absolute (starts with http/https), it is returned unchanged.
 */
export function toAbsolute(statusUrl: string, baseUrl?: string): string {
  if (baseUrl === undefined) return statusUrl;
  if (/^https?:\/\//i.test(statusUrl)) return statusUrl;
  return `${baseUrl.replace(/\/$/, '')}/${statusUrl.replace(/^\//, '')}`;
}

export function getCustomerInitials(name: string) {
  if ((name.length === STR_MIN) || typeof name !== 'string') return '';

  const words = name.trim().split(/\s+/);

  if (words.length === FORM_LEN) {
    // Single name: take first two letters
    return words[STR_MIN].slice(STR_MIN, STR_MAX).toUpperCase();
  }

  // Multiple words: take first letter of first two words
  return words
    .slice(STR_MIN, STR_MAX)
    .map(word => word[STR_MIN])
    .join('')
    .toUpperCase();
}
